import colors from '../../../utils/colors';
import { ResponsiveLineCanvas } from '@nivo/line';
import React from 'react';

type Props = {
  data: any;
  valueFormatter?: any;
};

function DataPerDay({ data, valueFormatter }: Props) {
  return (
    <ResponsiveLineCanvas
      margin={{ top: 30, right: 20, bottom: 60, left: 40 }}
      data={[
        {
          id: 'signUpsPerDay',
          data
        }
      ]}
      colors={[colors.primaryPurple]}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
        useUTC: false,
        precision: 'day'
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{
        type: 'linear',
        stacked: false
      }}
      {...(valueFormatter ? { yFormat: valueFormatter } : undefined)}
      axisLeft={{
        legend: 'signups',
        legendOffset: 12,
        ...(valueFormatter ? { format: valueFormatter } : undefined)
      }}
      axisBottom={{
        format: '%b %d',
        tickValues: 'every day',
        legend: 'days',
        legendOffset: -12
      }}
      curve={'linear'}
      pointSize={4}
      pointBorderWidth={1}
      pointBorderColor={{
        from: 'color',
        modifiers: [['darker', 0.3]]
      }}
      enableSlices={false}
    />
  );
}

export default DataPerDay;
